import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { EndpointService } from "@app/core";
import { ToastrService } from "ngx-toastr";
import { reject } from "lodash";
import { error } from "console";
import { resolve } from "url";

export interface History {
  nombre: string;
  apellido: string;
  id: number;
  identificacion: number;
  motivo: Motivo;
  fecha_inicial: Date;
  fecha_final?: Date;
}

export interface Motivo {
  id: number;
  nombre: string;
}

@Injectable()
export class HistoryInactivateUserDataService {
  constructor(private http: HttpClient, private api: EndpointService, private toastr: ToastrService) {}

  /**
   * Obtiene el listado de usarios inactivados
   */
  getHistoryInactivationUsers(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.get<History[]>(this.api.get('historyUsersInactivation')).subscribe(
        history => {
          resolve(history);
        },
        err => {
          if(err.code == 400) {
            this.toastr.warning("Operación fallida", err.error);
          } else if (err.code == 403) {
            this.toastr.warning("Operación fallida", "Permisos insuficientes");
          } else {
            this.toastr.warning("Operación fallida", "No se pudo realizar la acción");
          }
          reject(err);
        }
      )
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/system-users-inactivation/history-inactivation-users/shared/history_inactivate_user-data.services.ts